/**
 * Menu mobile en tiroir (drawer).
 * Marqueurs : data-menu (le <nav>), data-menu-toggle (bouton burger), data-menu-close (bouton de fermeture
 * dans le tiroir), data-menu-backdrop (voile derrière le tiroir).
 * Dès 890px (voir $bp-menu dans _variables.scss) le <nav> redevient une navigation horizontale : le tiroir se referme tout seul.
 */
export class Menu {
  constructor(nav) {
    this.nav = nav;
    this.toggleBtn = document.querySelector('[data-menu-toggle]');
    this.closeBtn = nav.querySelector('[data-menu-close]');
    this.backdrop = document.querySelector('[data-menu-backdrop]');
    this.desktop = window.matchMedia('(min-width: 890px)');
    this.isOpen = false;

    this.onKeydown = this.onKeydown.bind(this);
    this.toggleBtn?.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
    this.closeBtn?.addEventListener('click', () => this.close());
    this.backdrop?.addEventListener('click', () => this.close());
    // un clic sur un lien d'ancre referme le tiroir (la page défile ensuite vers la section)
    nav.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => this.close(false)));
    this.desktop.addEventListener('change', () => this.desktop.matches && this.close(false));
  }

  open() {
    this.isOpen = true;
    this.lastFocus = document.activeElement;
    this.nav.classList.add('is-open');
    this.backdrop?.classList.add('is-open');
    document.documentElement.classList.add('menu-open'); // bloque le défilement de la page derrière
    this.toggleBtn?.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', this.onKeydown);
    this.closeBtn?.focus();
  }

  close(restoreFocus = true) {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.nav.classList.remove('is-open');
    this.backdrop?.classList.remove('is-open');
    document.documentElement.classList.remove('menu-open');
    this.toggleBtn?.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', this.onKeydown);
    if (restoreFocus) this.lastFocus?.focus();
  }

  // Échap ferme ; Tab reste dans le tiroir tant qu'il est ouvert
  onKeydown(e) {
    if (e.key === 'Escape') return this.close();
    if (e.key !== 'Tab') return;
    const items = [...this.nav.querySelectorAll('button, a[href]')];
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
}

export function initMenu() {
  document.querySelectorAll('[data-menu]').forEach((nav) => new Menu(nav));
}
